export default defineNuxtPlugin(() => {
  function isTablet () {
    return window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches;
  }

  const meta = document.querySelector('meta[name=viewport]');
  meta && meta.setAttribute('content', isTablet() ? 'width=1024' : 'width=device-width, initial-scale=1');

  window.matchMedia('(orientation: portrait)').addEventListener('change', function (e) {
    meta && meta.setAttribute('content', isTablet() && e.matches ? 'width=1024' : 'width=device-width, initial-scale=1');
  });
});
